import { PayMCopyDateModelAdd, payMCopyDateStatusInversed, PayMCopyDateStatusKeys } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import TableWithoutVirtualListing, { TableWithoutDefaultRowRenderer } from '../../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { InputCalendarStateFull } from '../../../../../../../forms/Input/InputCalendar'
import { RectangularInputPrice } from '../../../../../../../forms/Input/InputPrice'
import { CustomSelectWithSearchBar } from '../../../../../../../forms/CustomSelect'
import { parsePaymentMethodDatesCopy } from './functions'
import { PaymentTypesPayload } from '../../../../../../../utils/reducers/payments/paymentTypes'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useGetDictPaymentBanks from '../../../../../../../utils/hooks/payments/getDictPaymentBanks'
import useDictPaymentTypes from '../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod/useDictPaymentTypes'
import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'
import NullComponent from '../../../../../../../baseComponents/NullComponent'
import { addDictionaryExtraLine } from '../../../../../../../utils/globals/dictionary'
import { TableWithoutVirtualListingRowProps } from '../../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import useCollectionAndPaymentStatus from '../../../../../../../utils/hooks/accounting/useCollectionAndPaymentStatus'
import { InputWithLabelMargin } from '../../../../../../../forms/Input'
import ModalGroupPaymentMethodDate from './ModalGroupPaymentMethodDate'
import { EditPaymentMethodCopyDateTy, UseEditPaymentMethodModalProps } from './types'
import { DeniedPaymentMethodDateIcon, HeaderModalEditPaymentMethodDate, ManagePaymentMethodDateIcon, RenderPaymentMethodDateLogs } from './Subcomponents'
import { DisplayStatus } from '../../../../../../../baseComponents/Displays/DisplayStatus'
import ModalDeniedPaymentMethodCopyDate from './ModalDeniedPaymentMethodCopyDate'
import ModalManagePaymentMethodDate from './ModalManagePaymentMethodDate'
import { ModalBig } from '../../../../../../../baseComponents/Modal'
import LoaderDecider from '../../../../../../../baseComponents/LoaderDecider'
import ModalLogsPaymentMethodDate from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout/ModalsOrderSellLayout/ModalLogsPaymentMethodDate'
import './modalEditPaymentMethodDate.sass'


type ModalEditPaymentMethodDateProps = ModalEditComponentProps & ReduxModalEditPaymentMethodDate & { }

const ModalEditPaymentMethodDate: React.FC<ModalEditPaymentMethodDateProps> = ({ allRowData, setOpened, paymentTypes, onSubmit}) => {
    const {t} = useTwinTranslation()
    const { data, dictPaymentTypes, paymentTypesMemo, openModal, setOpenModal, getPaymentCopyDates } = useModalEditPaymentMethodDateLogic({allRowData, paymentTypes, setOpened, onSubmit})
    const { customRowRender } = useModalEditPaymentMethodDateTableLogic({ allRowData })
    const { collectionAndPaymentStatus } = useCollectionAndPaymentStatus()

    const columns: ColumnTableSchema<PayMCopyDateModelAdd> = [
        {
            id: 'date',
            dataKey: 'date',
            label: t('date', 'Fecha'),
            customRender: (parameterValue, allRowData) => <InputCalendarStateFull hideLabel={true}  className='input_calendar_hide_label' label={''} value={parameterValue} minDate={new Date()} readOnly={true} onlyValids={true} />,
            className: 'overflow-visible',
            width: 120
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            customRender: (parameterValue, allRowData) => <RectangularInputPrice readOnly={true} label={''} CurrencyId={allRowData?.CurrencyId} value={parseFloat(String(parameterValue))} />,
        },
        {
            id: 'PaymentTypeId',
            dataKey: 'PayTCopyId',
            label: t('paymentTypeN', 'Tipo de pago'),
            customRender: (parameterValue, allRowData) => <CustomSelectWithSearchBar items={paymentTypesMemo} label='' className='w-full custom_select_hide_label height_28' sortItems={true}  value={allRowData?.PaymentTypeId} readOnly={true} />,
            className: 'overflow-visible w-full',
        },
        {
            id: 'id',
            dataKey: 'id',
            label: t('info', 'Información'),
            customRender: (parameterValue, allRowData) => {
                const element = dictPaymentTypes?.[paymentTypesMemo[(allRowData?.PaymentTypeId || 1)]?.relatedType as PaymentRelatedTypesKeys]
                const Component = element?.component || NullComponent
                const className = (element?.extraProps?.className || '') + (element?.component === InputWithLabelMargin ? 'input_field_hide_label w-full' : '')
                return <Component {...allRowData} {...element?.extraProps} value={allRowData?.new_extra_payment_data} readOnly={true} className={className} />
            },
            className: 'overflow-visible w-full',
        },
        {
            id: 'status',
            dataKey: 'status',
            label: t('status', 'Estado'),
            customRender: (parameterValue) =>  <DisplayStatus text={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.name} colorText={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.colorText} icon={collectionAndPaymentStatus[parseInt(parameterValue) as PayMCopyDateStatusKeys]?.icon} />,
            className: 'overflow-visible w-full',
        },
        {
            id: 'logs',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue, allRowData) => <RenderPaymentMethodDateLogs  {...{ allRowData, setOpenModal }} />  ,
            className: 'overflow-visible',
            width: 40,
        },
        {
            id: 'manage',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue, allRowData) => <ManagePaymentMethodDateIcon {...{allRowData, setOpenModal}} />,
            className: 'overflow-visible',
            width: 40,
        },
        {
            id: 'cancel',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue, allRowData) => <DeniedPaymentMethodDateIcon {...{ allRowData, setOpenModal }} />,
            className: 'overflow-visible',
            width: 40,
        },
    ]

    return (
        <ModalBig opened={true} setOpened={setOpened} onClickOut={false} className='flex flex-col'>
            <LoaderDecider loading={!data}>
                <Fragment>
                    <HeaderModalEditPaymentMethodDate availableGroup={data?.availableGroup || false} full_assigned_number={allRowData?.['PayMCopy.SellInvoice.full_assigned_number']} {...{setOpenModal}} />
                    <div className='flex-auto overflow-visible'>
                        <TableWithoutVirtualListing data={data?.paymentCopyDates || []} columns={columns} rowRenderer={customRowRender} />
                    </div>
                    {openModal?.type === 'group' ? <ModalGroupPaymentMethodDate setOpened={setOpenModal} onSubmit={getPaymentCopyDates}  paymentCopyDates={data?.paymentCopyDates || []} {...{ paymentTypesMemo, dictPaymentTypes }} /> : null}
                    {openModal?.type === 'manage' ? <ModalManagePaymentMethodDate setOpened={() => setOpenModal(null)} onSubmit={getPaymentCopyDates} {...{ paymentTypesMemo, dictPaymentTypes, openModal }} /> : null}
                    {openModal?.type === 'denied' ? <ModalDeniedPaymentMethodCopyDate setOpened={() => setOpenModal(null)} onSubmit={getPaymentCopyDates} allRowData={openModal?.allRowData} /> : null}
                    {openModal?.type === 'showLogs' ? <ModalLogsPaymentMethodDate setOpened={() => setOpenModal(null)} onSubmit={getPaymentCopyDates} allRowData={openModal?.allRowData} /> : null}
                </Fragment> 
            </LoaderDecider>
        </ModalBig>
    )
}

interface ModalEditPaymentMethodDateLogicProps extends ModalEditComponentProps {
    paymentTypes: PaymentTypesPayload
}

const useModalEditPaymentMethodDateLogic = ({ allRowData, paymentTypes }: ModalEditPaymentMethodDateLogicProps) => {
    const [data, setData] = useState<EditPaymentMethodCopyDateTy>(null)
    const [openModal, setOpenModal] = useState<UseEditPaymentMethodModalProps>(null)
    const { dictPaymentBanks } = useGetDictPaymentBanks({ CustomerId: allRowData?.['PayMCopy.CustomerId'], WorkingCenterId: allRowData?.['PayMCopy.BillingWorkingCenterId'] })
    const { dictPaymentTypes } = useDictPaymentTypes({ dictPaymentBanks })
    const paymentTypesMemo = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentTypes?.all || {}))), [paymentTypes?.all])

    const getPaymentCopyDates = useCallback(async () => {
        if (allRowData?.PayMCopyId){
            const response = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/getAllPaymentMethodCopyDateCompleteByParentId', { PayMCopyId: allRowData?.PayMCopyId })
            let availableToGroup = 0
            const statusNotToGroup = [payMCopyDateStatusInversed['grouped'], payMCopyDateStatusInversed['divided'], payMCopyDateStatusInversed['payed']]
            if(response){
                for (const element of response) {
                    if(!statusNotToGroup.includes(element.status)){
                        availableToGroup++
                    }
                }
            }
            setData({ paymentCopyDates: parsePaymentMethodDatesCopy(response || []), copyPaymentCopyDates: parsePaymentMethodDatesCopy(response || []), availableGroup: availableToGroup >2? true: false})
        }
    }, [setData, allRowData?.PayMCopyId])

    useEffect(() => {
        getPaymentCopyDates()
    }, [getPaymentCopyDates])

    return { data, setData, dictPaymentTypes, paymentTypesMemo, openModal, setOpenModal, getPaymentCopyDates }
}

interface ModalEditPaymentMethodDateTableLogicProps {
    allRowData?: RowData
}

const useModalEditPaymentMethodDateTableLogic = ({ allRowData }: ModalEditPaymentMethodDateTableLogicProps) => {

    const customRowRender = useCallback((props: TableWithoutVirtualListingRowProps) => {
        if (parseInt(String(props.rowData.id)) === parseInt(String(allRowData?.id))) {
            props.className = 'selected_payment_method_copy_date ' + (props.className || '')
        }
        return <TableWithoutDefaultRowRenderer {...props} key={props.rowData?.subId || props.rowData?.id} className={'overflow-visible ' + (props.className || '')} />
    }, [allRowData?.id])

    return { customRowRender }
}


const modalEditPaymentMethodDateDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
}

type ReduxModalEditPaymentMethodDate = ConnectedProps<typeof modalEditPaymentMethodDateConnect>
const mapModalEditPaymentMethodDateConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes})
const modalEditPaymentMethodDateConnect = connect(mapModalEditPaymentMethodDateConnector, modalEditPaymentMethodDateDispatch)
const taskConnectLoading = withLoading(ModalEditPaymentMethodDate, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }])
const ModalEditPaymentMethodDateConnect = modalEditPaymentMethodDateConnect(taskConnectLoading)
export default ModalEditPaymentMethodDateConnect